<template>
    <div class="full-width" :style="pageStyle" v-loading="loading">
        <HomeHeader
            :returnLabel="i18n.tkey('lang_return')"
            :useChatBtn="true"
            @clickBackBtn="clickReturnFunc"
            v-show="showReturnBtn !== false && viewPart == 'list'"
        />

        <div class="title-operation-part">
            <div>
                <span class="page-title-span" v-show="viewPart == 'list'" tkey="報價單">{{i18n.tkey("lang_quotation")}}</span>
                <el-button size="large" @click="goListPart" v-show="viewPart == 'print'" tkey="返回">{{i18n.tkey("lang_return")}}</el-button>
            </div>

            <div v-show="viewPart == 'print'">
                <el-button type="primary" circle @click="clickDownloadBtn">
                    <font-awesome-icon icon="fa-solid fa-download" />
                </el-button>
            </div>

        </div>

        <div v-show="viewPart == 'list'">
            <quotationList :list="list" v-if="list.length > 0" @clickPrint="goPrintRecord" />

            <div>
                <el-empty :description="i18n.tkey('lang_temporary_no_data')" v-if="list.length == 0">

                </el-empty>
            </div>
        </div>

        <div v-if="viewPart == 'print'">
            <quotationPrinter :quotationRef="printRef" :acccompanycode="printCompanyCode" ref="printerDom" />
        </div>

    </div>
</template>

<script setup>
    import {inject, onBeforeMount, provide, ref, toRef, getCurrentInstance} from "vue";
    import {useUserinfo} from "@/stores/userinfo";
    import eshopopeeApi from "@/request/eshopopeeApi";
    import myUtil from "@/util/util";
    import quotationList from "@/components/shopopee/quotation/quotationList"
    import quotationPrinter from "@/components/shopopee/print/quotationPrinter"
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import {faDownload} from '@fortawesome/free-solid-svg-icons'
    import HomeHeader from "@/components/shopopee/pageHeader/homeHeader.vue";

    library.add(faDownload)

    const props = defineProps(["fullScreen", "showReturnBtn"])

    const userInfoRef = toRef(useUserinfo())
    const i18n = inject("i18n")
    const loading = ref(false)
    const pageStyle = ref(null)
    const { proxy } = getCurrentInstance()

    const { goDisplayIndexView } = inject('phoneView', { goDisplayIndexView: () => { proxy.$router.push({name: "home"} )} })

    const list = ref([])

    const viewPart = ref("list")
    const printCompanyCode = ref(null)
    const printRef = ref(null)

    const printerDom = ref(null)

    function getQuotationList(){
        const request = eshopopeeApi.getAllQuotationList
        const params = request.getParams()

        params.login = userInfoRef.value.login

        request.send(params, (res) => {
            list.value = res.list
        })

    }

    function clickReturnFunc(){
        goDisplayIndexView()
    }

    function goListPart(){
        viewPart.value = "list"
        printCompanyCode.value = null
        printRef.value = null
    }

    function goPrintRecord(ref, companycode){
        printRef.value = ref
        printCompanyCode.value = companycode
        viewPart.value = "print"
    }

    function clickDownloadBtn(){
        printerDom.value.downloadImg()
    }

    onBeforeMount(() => {
        if (props.fullScreen === false){
            pageStyle.value = {}
        }else{
            pageStyle.value = {
                width: `${window.innerWidth}px`,
                height: `${window.innerHeight}px`
            }
        }

        if (myUtil.isNotEmpty(userInfoRef.value.login)){
            getQuotationList()
        }
    })
</script>

<style scoped>
    .full-width {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        overflow-x: hidden;
        overflow-y: auto;
        text-align: left;
    }

    .title-operation-part {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50px;
        box-sizing: border-box;
        padding: 0 10px;
    }

    .page-main-part {
        width: 100%;
        height: calc(100% - 50px);
        box-sizing: border-box;
    }

    .page-title-span {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
    }

    .paddding-part {
        padding: 10px;
    }
</style>